/* ═══ MİSAK — Shopify Theme JS ═══ */
(function () {
  "use strict";

  /* ── Header scroll state ── */
  function initHeader() {
    var h = document.getElementById("mkHeader");
    if (!h) return;
    var onScroll = function () { h.classList.toggle("scrolled", window.scrollY > 24); };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  /* ── Mobile nav ── */
  function initMobileNav() {
    var btn = document.getElementById("mkBurger");
    var nav = document.getElementById("mkMnav");
    if (!btn || !nav) return;
    function set(open) {
      btn.classList.toggle("open", open);
      btn.setAttribute("aria-expanded", String(open));
      nav.classList.toggle("open", open);
      nav.setAttribute("aria-hidden", String(!open));
      document.body.style.overflow = open ? "hidden" : "";
    }
    btn.addEventListener("click", function () {
      set(btn.getAttribute("aria-expanded") !== "true");
    });
    nav.querySelectorAll("a").forEach(function (a) {
      a.addEventListener("click", function () { set(false); });
    });
  }

  /* ── Announcement dismiss ── */
  function initAnn() {
    var bar = document.getElementById("mkAnn");
    var close = document.getElementById("mkAnnClose");
    if (!bar || !close) return;
    try { if (sessionStorage.getItem("mk-ann-closed") === "1") { bar.style.display = "none"; } } catch (e) {}
    close.addEventListener("click", function () {
      bar.style.display = "none";
      try { sessionStorage.setItem("mk-ann-closed", "1"); } catch (e) {}
    });
  }

  /* ── Scroll reveal ── */
  function initReveal() {
    var items = document.querySelectorAll(".reveal");
    if (!items.length) return;
    if (!("IntersectionObserver" in window)) {
      items.forEach(function (el) { el.classList.add("is-vis"); });
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add("is-vis"); obs.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    items.forEach(function (el) { obs.observe(el); });
  }

  /* ── Gallery thumbnails ── */
  function initGallery() {
    var main = document.getElementById("mkMainImg");
    var thumbs = document.querySelectorAll(".mk-thumb");
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (t) {
      t.addEventListener("click", function () {
        var src = t.getAttribute("data-src");
        if (!src) return;
        main.style.opacity = "0";
        setTimeout(function () { main.src = src; main.style.opacity = "1"; }, 150);
        thumbs.forEach(function (x) { x.classList.remove("active"); });
        t.classList.add("active");
      });
    });
  }

  /* ── Quantity stepper ── */
  function initQty() {
    var qty = document.getElementById("mkQty");
    var hidden = document.getElementById("mkQtyHidden");
    var minus = document.getElementById("mkQtyMinus");
    var plus = document.getElementById("mkQtyPlus");
    if (!qty) return;
    function clamp(v) {
      v = parseInt(v, 10);
      if (isNaN(v) || v < 1) v = 1;
      if (v > 20) v = 20;
      qty.value = v;
      if (hidden) hidden.value = v;
      var bar = document.getElementById("mkBarQty");
      if (bar) bar.textContent = v;
    }
    if (minus) minus.addEventListener("click", function () { clamp(+qty.value - 1); });
    if (plus) plus.addEventListener("click", function () { clamp(+qty.value + 1); });
    qty.addEventListener("change", function () { clamp(qty.value); });
    clamp(qty.value);
  }

  /* ── Mobile buy bar: kaldırıldı — Releasit kendi yapışkan (sticky) butonunu sağlıyor ── */

  /* ── FAQ accordion ── */
  function initFaq() {
    var qs = document.querySelectorAll(".mk-faq__q");
    if (!qs.length) return;
    qs.forEach(function (btn) {
      btn.addEventListener("click", function () {
        var open = btn.getAttribute("aria-expanded") === "true";
        qs.forEach(function (b) {
          b.setAttribute("aria-expanded", "false");
          var a = b.nextElementSibling;
          if (a) a.classList.remove("open");
        });
        if (!open) {
          btn.setAttribute("aria-expanded", "true");
          var a = btn.nextElementSibling;
          if (a) a.classList.add("open");
        }
      });
    });
  }

  /* ── Smooth anchor scroll with sticky-header offset ── */
  function initSmoothScroll() {
    document.querySelectorAll('a[href*="#"]').forEach(function (a) {
      a.addEventListener("click", function (e) {
        var href = a.getAttribute("href");
        var hash = href.indexOf("#") > -1 ? href.slice(href.indexOf("#")) : "";
        if (!hash || hash === "#") return;
        var samePath = href.indexOf("#") === 0 || location.pathname === href.split("#")[0] || href.split("#")[0] === "";
        if (!samePath) return;
        var target = document.querySelector(hash);
        if (!target) return;
        e.preventDefault();
        var header = document.getElementById("mkHeader");
        var offset = (header ? header.offsetHeight : 0) + 18;
        var top = target.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top: top, behavior: "smooth" });
        history.replaceState(null, "", hash);
      });
    });
  }

  function init() {
    initHeader();
    initMobileNav();
    initAnn();
    initReveal();
    initGallery();
    initQty();
    initFaq();
    initSmoothScroll();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
